// extracted by mini-css-extract-plugin
export var author = "PassengerShowcasePanel-module--author--37a1c";
export var authorName = "PassengerShowcasePanel-module--authorName--b56f8";
export var contrib = "PassengerShowcasePanel-module--contrib--ef806";
export var contributions = "PassengerShowcasePanel-module--contributions--a8e28";
export var image = "PassengerShowcasePanel-module--image--9f723";
export var noImage = "PassengerShowcasePanel-module--noImage--05d4e";
export var pictureContainer = "PassengerShowcasePanel-module--pictureContainer--94144";
export var playButton = "PassengerShowcasePanel-module--playButton--902d0";
export var root = "PassengerShowcasePanel-module--root--c4ed5";
export var showcasePanel = "PassengerShowcasePanel-module--showcasePanel--97800";
export var spacer = "PassengerShowcasePanel-module--spacer--d623a";
export var title = "PassengerShowcasePanel-module--title--5f7ca";
export var titleBox = "PassengerShowcasePanel-module--titleBox--89d5e";